import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'
import { covertBoolStringToBool } from 'app/utils/strings/helpers'
import { isApplicationRentalLedgerRequiredSettingEnabled } from 'config/features'

type ApplicationAttributes = Record<string, unknown>

export const parseApplicationRentalLedgerRequiredSetting = (
  application: ApplicationAttributes = {},
): boolean => {
  const value =
    application[applicationsAttributesIDs.applicationRentalLedgerRequired]
  return covertBoolStringToBool(value)
}

interface BuildApplicationRentalLedgerRequiredSettingPayloadArgs {
  isAccountPremier: boolean
  enabled: boolean
}

export const buildApplicationRentalLedgerRequiredSettingPayload = ({
  isAccountPremier,
  enabled,
}: BuildApplicationRentalLedgerRequiredSettingPayloadArgs): Record<
  string,
  string
> => {
  if (!isApplicationRentalLedgerRequiredSettingEnabled(isAccountPremier)) {
    return {}
  }

  return {
    [applicationsAttributesIDs.applicationRentalLedgerRequired]:
      enabled.toString(),
  }
}
